const state = () => ({
  tasks: [],
  showInbox: false,
  durationLogs: [],
});

const getters = {
  tasks: state => {
    return state.tasks;
  },
  showInbox: state => {
    return state.showInbox;
  },
  durationLogs: function (state) {
    return state.durationLogs;
  },
};

const mutations = {
  SET_TASKS (state, payload) {
    state.tasks = payload;
  },
  SET_INBOX_VIEW: function (state, inboxStatus = !state.show_inbox) {
    state.showInbox = inboxStatus;
  },
};

const actions = {
  SET_TASKS ({ commit }, payload) {
    commit('SET_TASKS', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
